import React from 'react';
import PaymentSuccess from '../../components/Payments/PaymentSuccess';

const Success = () => {
  return <PaymentSuccess />;
};

export default Success;
